import wixData from 'wix-data';

$w.onReady(function () {
});

// Filter by "Voucher ID"
function filter(search) {
	$w('#dataset1').setFilter(wixData.filter().contains("Voucher ID", search));
	//$w('#dataset1').setFilter(wixData.filter().contains("Customer Name", search));
	
}



export function searchButton_click(event) {
		filter($w('#searchVoucherIDInput').value);
		//filter($w('#searchVoucherFirstNameInput').value);
}

export function searchVoucherIDInput_keyPress(event) {
	filter($w('#searchVoucherIDInput').value);
}